/* eslint-disable no-console */
import React, { Component } from 'react';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// our components
import { NOTIFICATION_TYPE } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import { Mutation } from 'components/common/Query';
import NotificationTypeForm from 'components/NotificationType/Form';

/**
 * Mutation to create a notification type
 */
export const CREATE_NOTIFICATION_TYPE_MUTATION = gql`
  mutation(
    $name: String!
    $description: String!
    $photo: String
    $category: ID!
    $enableSendPush: Boolean!
    $enableSendEmail: Boolean!
    $defaultUserSettingsEmail: Boolean!
    $defaultUserSettingsPush: Boolean!
    $strategy: NotificationTypeFormStrategy!
    $example: String
    $parameters: String
    $isCritical: Boolean!
  ) {
    createNotificationType(
      input: {
        name: $name
        description: $description
        photo: $photo
        category: $category
        enableSendPush: $enableSendPush
        enableSendEmail: $enableSendEmail
        defaultUserSettingsEmail: $defaultUserSettingsEmail
        defaultUserSettingsPush: $defaultUserSettingsPush
        strategy: $strategy
        example: $example
        parameters: $parameters
        isCritical: $isCritical
      }
    ) {
      notificationType {
        id
        __typename
      }
      errors {
        field
        messages
        __typename
      }
      clientMutationId
      __typename
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class NotificationTypeCreateContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.Compose = adopt({
      mutateNotificationTypeCreate: this.notificationTypeCreate,
    });
  }

  /**
   * @description
   * Mutation callback to compose with list query.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  notificationTypeCreate = ({ render }) => (
    <Mutation
      mutation={CREATE_NOTIFICATION_TYPE_MUTATION}
      onCompleted={this.notificationTypeCreateCompleted}
    >
      {(handleNotificationTypeCreate, { loading }) =>
        render({ handleNotificationTypeCreate, loadingCreate: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation callback when create notification type is completed.
   *
   * @param {Object} createNotificationType - Mutation result.
   */
  notificationTypeCreateCompleted = async ({ createNotificationType }) => {
    const history = this.context;
    const { errors } = createNotificationType;
    if (!errors) {
      history.push(NOTIFICATION_TYPE.LIST);
    } else {
      this.setState({ errors });
    }
  };

  /**
   * @description
   * Close notification.
   * @returns {undefined} - No returns value.
   */
  handleCloseNotification = () => {
    this.setState({ errors: [] });
  };

  /**
   * @description
   * Render NotificationTypeForm component.
   *
   * @returns {*} Component to render.
   */
  render() {
    const { errors } = this.state;
    return (
      <this.Compose>
        {({
          mutateNotificationTypeCreate: {
            handleNotificationTypeCreate,
            loadingCreate,
          },
        }) => (
          <NotificationTypeForm
            handleNotificationTypeSave={notificationType => {
              // eslint-disable-next-line no-unused-vars
              const { id, ...notificationTypeData } = notificationType;
              return handleNotificationTypeCreate({
                variables: notificationTypeData,
              });
            }}
            errors={errors}
            submitLoading={loadingCreate}
            closeNotification={this.handleCloseNotification}
          />
        )}
      </this.Compose>
    );
  }
}

export default NotificationTypeCreateContainer;
